
const signup = {
  fr: {
    signup: {
      advertiserName: 'Nom de la compagnie',
      email: 'Courriel',
      firstName: 'Nom',
      surname: 'Nom de famille',
      password: 'Mot de passe',
      confirmPassword: 'Confirmation de mot de passe',
      signup: 'S\'inscrire',
      signin: 'Se connecter',
      invalidEmailMessage: 'Le courriel est invalide',
      invalidPasswordMessage: 'Les mots de passe ne correspondent pas',
      passwordValidationMessage: 'Votre mot de passe doit contenir au moins 8 caractères et une majuscule et/ou un chiffre et/ou un caractère special',
      alreadyHaveAnAccount: 'Vous avez déjà un compte ?',
      createYourAccount: 'Créez votre compte !',
      cantSignUp: 'Une erreur est survenue lors de la création du compte',
      campaignAlreadyLinked: 'La campagne est déjà liée à un compte',
      propositionAlreadyLinked: 'La proposition est déjà liée à un compte',
      mustNotBeEmpty: 'Ce champ est requis',
      statsRadioAccountPresent: 'Un compte StatsRadio existe déjà',
      // eslint-disable-next-line max-len
      statsRadioAccountPresentMessage: 'Vous possédez déjà un compte utilisateur sur StatsRadio. Celui-ci à été lié à votre annonceur. Utilisez les informations de connexions de ce dernier.',
    },
  },
  en: {
    signup: {
      advertiserName: 'Company Name',
      email: 'Email',
      firstName: 'First Name',
      surname: 'Surname',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      signup: 'Sign Up',
      signin: 'Sign In',
      invalidEmailMessage: 'Email is invalid',
      invalidPasswordMessage: 'Passwords do not correspond',
      passwordValidationMessage: 'Your password must contain at least 8 characters and an uppercase and / or a number and / or a special character',
      alreadyHaveAnAccount: 'Already have an account ?',
      createYourAccount: 'Create your own account !',
      cantSignUp: 'An error occurred during the signup',
      campaignAlreadyLinked: 'The campaign is already linked to an account',
      propositionAlreadyLinked: 'The proposition is already linked to an account',
      mustNotBeEmpty: 'Must not be empty',
      statsRadioAccountPresent: 'StatsRadio Account already created',
      // eslint-disable-next-line max-len
      statsRadioAccountPresentMessage: 'Since you are already a user in StatsRadio, your advertiser was linked to your StatsRadio account. Please also use this account to login on Follo in the future.',
    },
  },
};

export default signup;



// WEBPACK FOOTER //
// ./src/advertisers/modules/signup/i18n/signup.js